/* eslint-disable import/prefer-default-export */
export const POSTS = [
  {
    title: 'How Lemonade Became a Precocious 5-Year-Old',
    summary: 'Secrets I couldn’t tell now: A Transparency Chronicle on the 5th anniversary of Lemonade.',
    url: 'https://www.lemonade.com/blog/lemonade-turns-5/',
  },
  {
    title: 'The Sixth Sense',
    summary:
      'Blond wigs, weird bots, and ad fails: The 2019 behind-the-scenes secrets and stats in the latest Lemonade Transparency Chronicle.',
    url: 'https://www.lemonade.com/blog/the-sixth-sense/ ',
  },
  {
    title: 'Zero-to-100 Million in 3 Years',
    summary:
      '500% growth, 10% market share, ranked #1 by consumers: Our third anniversary Transparency Chronicle reveals all the latest juicy numbers and metrics.',
    url: 'https://www.lemonade.com/blog/zero-to-100/ ',
  },
  {
    title: 'Signals From Space: Summing Up 2018',
    summary:
      '2018 was a blast, from building mad science projects to accelerating to escape velocity. Get the numbers, secrets, and epic fails behind it all in our latest Transparency Chronicle.',
    url: 'https://www.lemonade.com/blog/signals-from-space/ ',
  },
  {
    title: 'Two Years of Lemonade: A Super Transparency Chronicle',
    summary:
      'Lemonade transparency, 24 months in: summing up the first two years in market, revealing our latest stats, what we’ve been up to, and where we’re headed.',
    url: 'https://www.lemonade.com/blog/two-years-transparency',
  },
  {
    title: 'The Lemonade 2018 Social Impact Report',
    summary: 'The Lemonade Giveback grows 3x, with more than $162,000 distributed to 15 charities',
    url: 'https://www.lemonade.com/blog/lemonade-giveback-2018',
  },
  {
    title: 'We Suck, Sometimes: Highs and Lows of Lemonade’s First Half of 2018',
    summary:
      'After 20 months in market, we thought it would be nice to share some updates about our growth, national and ' +
      'team expansion, Henry the cat, our squad structure, and some things that still don’t work well, like our loss ratio.',
    url: 'https://www.lemonade.com/blog/lemonade-transparency-review/',
  },
  {
    title: '2017 Edition Transparency Chronicle',
    summary:
      'In late 2016 we were nervous as hell. We were about to launch a challenge to a $3 trillion industry, ' +
      'and it was anyone’s guess how we’d be received. Now, a full year’s worth of data offers some answers.',
    url: 'https://www.lemonade.com/blog/2017-transparency-chronicle/',
  },
  {
    title: 'The Thanksgiving 2017 Transparency Chronicle',
    summary:
      'It’s time to reflect on how our milestones have been received, reveal our latest metrics and stats, ' +
      'and share what we, Team Lemonade, are thankful for.',
    url: 'https://www.lemonade.com/blog/thanksgiving-2017-transparency-chronicle/',
  },
  {
    title: 'The Lemonade Insurance H1 2017 Underwriting Report',
    summary:
      'The underwriting and claims stats and the details behind our big reinsurance partnership, ' +
      'almost a year in.',
    url: 'https://www.lemonade.com/blog/lemonade-h1-underwriting-report-2017/',
  },
  {
    title: 'Time to Giveback: Lemonade’s 2017 Social Impact Report',
    summary:
      'Once a year, Lemonade gives back underwriting profits to nonprofits. So how much was ' +
      'the 2017 Giveback? Here are the stats, implications and feelings.',
    url: 'https://www.lemonade.com/blog/time-to-giveback/',
  },
  {
    title: 'Eight Months In: A Look Behind The Scenes Into The Reinvention Of Insurance',
    summary:
      'We’ve learned so much in the eight months since our launch. We got some stuff wrong, iterated and ' +
      'improved, and hopefully we got some things right as well.',
    url: 'https://www.lemonade.com/blog/lemonade-exposed-eight-months/',
  },
  {
    title:
      'The Social Impact Report By Prof. Dan Ariely: Stats On Our Giveback Program And The Causes We’re Working With',
    summary:
      'As Chief Behavioral Officer, I’m tasked with helping make Lemonade trusting and trustworthy. ' +
      'I spent years researching honesty and distrust, and Lemonade’s unique business model borrows heavily from ' +
      'that body of research.  Long story short: instead of fighting with our customers over the same coin, ' +
      'we join our customers in fighting for a common cause.',
    url: 'https://www.lemonade.com/blog/lemonade-social-impact-100-days/',
  },
  {
    title: 'The Lemonade Insurance Report: Loss Ratios, Written Premiums, And More (Not Just For Insurance Geeks!)',
    summary:
      'If you’re interested in how Lemonade is functioning from an insurance perspective, ' +
      'read on. I hope it will be less painful, and more revealing, than rummaging through regulatory filings.',
    url: 'https://www.lemonade.com/blog/transparency-chronicles-part-3-insurance-update/',
  },
  {
    title: 'Lemonade’s First Quarter In Market— Exposed',
    summary:
      'Exposing such sensitive information is counterintuitive, but we thought it’s important in our quest ' +
      'to make insurance an open, trusted and honest experience. Today, as part of our 2016 Transparency ' +
      'Chronicles, I’m sharing interesting metrics from our first quarter in market— Q4 of 2016.',
    url: 'https://www.lemonade.com/blog/lemonades-first-quarter-market/',
  },
  {
    title: 'The Lemonade Transparency Chronicles',
    summary:
      '2016 was an incredible year for Lemonade.  We ended the year as an insurance carrier licensed by ' +
      'the most exacting regulators, reinsured by the most trusted names, and funded by the most respected VCs. ' +
      'More exciting yet, our A.I. has been selling policies and paying claims to a growing stream of ' +
      'enthusiastic consumers, 80% of whom never bought insurance before!',
    url: 'https://www.lemonade.com/blog/lemonade-transparency-chronicles/',
  },
  {
    title: 'The Secret Behind Lemonade’s Instant Insurance',
    summary:
      'Hey everyone. It’s been almost a month since my last update where we exposed the metrics from ' +
      'Lemonade’s first 48 hours. Today, I wanted to let you in on some of the secret stuff that drives our ' +
      'unique claims experience.',
    url: 'https://www.lemonade.com/blog/secret-behind-lemonades-instant-insurance/',
  },
  {
    title: 'Lemonade Launch Metrics Exposed!',
    summary:
      'What we’re about to do here doesn’t come easy. But I’ll do it anyway. When we started this ' +
      'company, we knew that Transparency and Honesty were going to be among our core values…',
    url: 'https://www.lemonade.com/blog/lemonade-launch-metrics-exposed/',
  },
];
